import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from "vuex";
import { gainAdvAdd } from '@/api/auth/onlineUser';
export default {
  data: function data() {
    return {
      paramsData: {
        id: '',
        email: '',
        emailId: []
      },
      dialogShow: false,
      usersListS: [],
      rules: {
        email: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        emailId: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: _objectSpread(_objectSpread({}, mapActions("d2admin/user", ["usersList"])), {}, {
    open: function open(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.usersList({
                  page: 1,
                  page_size: 1000
                });

              case 2:
                query = _context.sent;
                _this.usersListS = query.data;

                if (data) {
                  _this.paramsData = _objectSpread(_objectSpread({}, _this.paramsData), data);
                }

                _this.dialogShow = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        id: '',
        email: ''
      };
      this.$refs.ruleForm.clearValidate();
      this.dialogShow = false;
    },
    userchange: function userchange(e) {
      var _this2 = this;

      var list = [];
      this.usersListS.forEach(function (i) {
        if (_this2.paramsData.emailId.findIndex(function (j) {
          return j == i.id;
        }) > -1) {
          list.push(i.email);
        }
      });
      this.paramsData.email = list.toString();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          gainAdvAdd(_this3.paramsData).then(function (res) {
            if (res.status == 200) {
              _this3.$message({
                message: '操作成功',
                type: 'success'
              });

              _this3.clearData();

              _this3.$emit('refreshDataList');
            }
          });
        }
      });
    }
  })
};